import Print from './Print'

export default Print
// eslint-disable-next-line import/export
export * from './Print'
